var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-row", { attrs: { align: "center", justify: "center" } }, [
        _c("img", {
          staticStyle: { "max-height": "30vh", "margin-top": "10vh" },
          attrs: {
            src: require("@/assets/kaista_logo.svg"),
            alt: "Kaista logo"
          }
        })
      ]),
      _c(
        "v-row",
        { staticClass: "mt-5", attrs: { align: "center", justify: "center" } },
        [_c("h1", [_vm._v("Payment")])]
      ),
      _c(
        "v-row",
        { staticClass: "mt-5", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    staticClass: "mb-3",
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: 50,
                      width: 5
                    }
                  })
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        large: "",
                        color: "primary",
                        loading: _vm.loading
                      },
                      on: { click: _vm.login }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("login.loginButton")) + " ")]
                  ),
              _c("p", { staticClass: "mt-3" }, [
                _vm.loading
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("login.redirectingMessage") ||
                            "Redirecting to login..."
                        )
                      )
                    ])
                  : _c("span", [_vm._v(_vm._s(_vm.$t("login.redirectInfo")))])
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }